import { connect } from 'react-redux'
import WalletPane from '../../../components/riders/riderdetails/wallet/WalletPane'
import { IRefundTransactionDTO, IStoreState } from '../../../types'
import {
  getRiderAutochargeConfig,
  getRiderWallet,
  getRiderWalletTransactions,
  getRiderWalletTransactionHistory,
  assignRefundDetails,
  removeRiderPaymentSource
} from '../../../state/actions/riders'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const orgId = state.organizations.currentOrgId
  return {
    rider: ownProps.rider,
    organizations: orgId ? state.organizations.items[orgId] : null,
    currentUserId: state.user.currentUserId
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getRiderWallet: (id: string) => {
      return dispatch(getRiderWallet(id))
    },
    getRiderWalletTransactions: (id: string) => {
      return dispatch(getRiderWalletTransactions(id))
    },
    getRiderWalletTransactionHistory: (id: string) => {
      return dispatch(getRiderWalletTransactionHistory(id))
    },
    getRiderAutochargeConfig: (id: string) => {
      return dispatch(getRiderAutochargeConfig(id))
    },
    assignRefundDetails: (params: IRefundTransactionDTO) => {
      return dispatch(assignRefundDetails(params))
    },
    removeRiderPaymentSource: (paymentSourceId: string, riderId: string) => {
      return dispatch(removeRiderPaymentSource(paymentSourceId, riderId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WalletPane)



// WEBPACK FOOTER //
// ./src/containers/riders/riderdetails/WalletPane.ts